import React, { useEffect } from 'react'
import { useStore } from 'hooks/useStore'
import { useLocales } from 'hooks/useLocales'

export const ParamRouter = ({ children }: { children: React.ReactNode }) => {
  const { urlParams } = useStore()
  const { messages } = useLocales()

  useEffect(() => {
    // Keep only the params that have a value
    const validParams = Object.fromEntries(
      Object.entries(urlParams).filter(([k, v]) => v != null)
    )

    // Constructs the url parameters string
    const validParamsList = Object.keys(validParams).map(
      k => `${k}=${validParams[k]}`
    )

    // Join the url parameter strings
    const paramsUrl =
      validParamsList.length > 0 ? `?${validParamsList.join('&')}` : ''

    // Change the url according to the params. If no params, go to the main page
    history.replaceState(validParams, '', paramsUrl || `/${messages.urlSlug}/`)

    window.scrollTo({
      left: 0,
      top: 0
    })
  }, [urlParams])

  return <div>{children}</div>
}

/**
 * Check the parameters in the url and returns the corresponding html
 * @param params
 * @param children
 * @param strict
 */
export const Route = ({
  children,
  params,
  strict,
  defaultRoute
}: {
  children: React.ReactNode
  params?: Array<string>
  strict?: boolean
  defaultRoute?: boolean
}) => {
  const { urlParams } = useStore()
  const urlParamsList = Object.entries(urlParams)
    .filter(([k, v]) => v != null)
    .reduce((a, b) => [b[0], ...a], [])

  if (params.length === 0 && urlParamsList.length === 0) {
    return <>{children}</>
  } else if (params.length > 0) {
    const paramsMatch = params.every((param, i) =>
      urlParamsList.some(p => p === param)
    )

    if (paramsMatch) {
      if (strict) {
        if (params.length === urlParamsList.length) {
          return <>{children}</>
        }
      } else {
        return <>{children}</>
      }
    } else if (defaultRoute && urlParamsList.length === 0) {
      return <>{children}</>
    }
  }
}

Route.defaultProps = {
  defaultRoute: false,
  strict: true,
  params: []
}
